import React, { useState, useRef, useEffect } from 'react';
import { createConsumer, getConfig } from '@rails/actioncable';
import { useSelector, useDispatch } from 'react-redux';
import { getRecommendationPreviews } from 'Shared/actions/organizations';
import PreviewModal from '../components/PreviewModal/PreviewModal';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  recommendationSetting;
  disabled;
};

const cable = createConsumer(getConfig('url'));

const PreviewButton = ({ recommendationSetting, disabled }: Props) => {
  const { id: userId } = useCurrentUser();
  const recommendation_previews_request_id = useSelector(state => state.recommendation_previews.request_id);
  const dispatch = useDispatch();
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const activatePreviewModal = () => {
    const recommendationSettingDataHash = Object.fromEntries(
      recommendationSetting.data.map(setting => [
        setting.key,
        typeof setting.value === 'number' ? setting.value.toString() : setting.value,
      ])
    );
    dispatch(getRecommendationPreviews(recommendationSetting.recommendation_type, recommendationSettingDataHash));
    setShowPreviewModal(true);
  };

  const togglePreviewModal = () => setShowPreviewModal(!showPreviewModal);

  // This is hacky but it was the only way I could see to subscribe to the channel at the start
  // but use the current value of recommendation_previews_request_id.
  // Making the useEffect depend on recommendation_previews_request_id would create a bunch
  // of unnecessary subscriptions
  // See here: https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
  // and ctrl+f for 'As a last resort, if you want something like this in a class'
  const recommendation_previews_request_id_Ref = useRef(recommendation_previews_request_id);

  useEffect(() => {
    recommendation_previews_request_id_Ref.current = recommendation_previews_request_id;
  });

  useEffect(() => {
    const createRecommendationPreviewsChannel = () =>
      cable.subscriptions.create(
        { channel: 'SidekiqJobChannel', user_id: userId },
        {
          received: json => {
            if (json.request_id === recommendation_previews_request_id_Ref.current) {
              dispatch({
                type: 'RECOMMENDATION_PREVIEWS_GET_RESPONSE',
                payload: json,
              });
            }
          },
        }
      );

    const recommendationPreviewsChannel = createRecommendationPreviewsChannel();
    return () => recommendationPreviewsChannel && recommendationPreviewsChannel.unsubscribe();
  }, []);

  return (
    <>
      <button type="button" onClick={activatePreviewModal} className="btn btn-secondary mr-4" disabled={disabled}>
        Preview
      </button>

      <PreviewModal
        onToggle={togglePreviewModal}
        isOpen={showPreviewModal}
        displayName="Custom Rule"
        onDoneClick={togglePreviewModal}
      />
    </>
  );
};

export default PreviewButton;
